

/**
 * Module to show You May Also Like Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.MayProducts = (function () {
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: 'may-like-products-list-2',
    layout: 'slider',
    swipe: true,
    media: 'adapt',
    onComplete: null,
  };
  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;


  var finalize = function () {
    var items = wrapper.find('.item');
    if (items.length <= 2)
      $('#may-like-products-list-2').addClass('left');

    $('#may-like-products-list-2').addClass('may-like-loaded');

    wrapper.show();
    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {}
    }
  };

  var doAlong = function () {
    if (productHandleQueue.length) {
      var url = window.routes.root + '/collections/all';

      const trips = productHandleQueue.join(encodeURIComponent(','));
      const nItemsLimit = productHandleQueue.length;

      $.ajax({
        type: 'get',
        url: url,
        cache: false,
        data: {
          view: 'ajax_recently_viewed',
          Pids: trips,
          limit: nItemsLimit ? nItemsLimit: config.howManyToShow,
          swipe: config.swipe,
          imageRatio: config.media,
          layout: config.layout,
        },
        beforeSend: function () {},
        success: function (data) {
          const recentlyViewedRow = $(
            '.halo-may-like-block .MayLikeProducts-row'
          );
          recentlyViewedRow.empty();
          wrapper.append(data);
        },
        error: function (xhr, text) {
          alert($.parseJSON(xhr.responseText).description);
        },
        complete: function () {
          if (config.layout == 'slider') {
            var wrapper = $('.halo-may-like-block'),
              productGrid = wrapper.find('.products-carousel'),
              itemToShow = productGrid.data('item-to-show'),
              itemDots = productGrid.data('item-dots'),
              itemDotsMb = productGrid.data('item-dots-mb'),
              itemArrows = productGrid.data('item-arrows'),
              itemArrowsMb = productGrid.data('item-arrows-mb');

            if (productGrid.length > 0) {
              if (productGrid.not('.slick-initialized')) {
                productGrid.slick({
                  mobileFirst: true,
                  adaptiveHeight: true,
                  vertical: false,
                  infinite: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: itemArrowsMb,
                  dots: itemDotsMb,
                  nextArrow: window.arrows.icon_next,
                  prevArrow: window.arrows.icon_prev,
                  rtl: window.rtl_slick,
                  responsive: [
                    {
                      breakpoint: 1599,
                      settings: {
                        arrows: itemArrows,
                        dots: itemDots,
                        get slidesToShow() {
                          if (
                            itemToShow !== undefined &&
                            itemToShow !== null &&
                            itemToShow !== ''
                          ) {
                            return (this.slidesToShow = itemToShow);
                          } else {
                            return (this.slidesToShow = 1);
                          }
                        },
                        get slidesToScroll() {
                          if (
                            itemToShow !== undefined &&
                            itemToShow !== null &&
                            itemToShow !== ''
                          ) {
                            return (this.slidesToScroll = itemToShow);
                          } else {
                            return (this.slidesToScroll = 1);
                          }
                        },
                      },
                    },
                    {
                      breakpoint: 1024,
                      settings: {
                        arrows: itemArrows,
                        dots: itemDots,
                        get slidesToShow() {
                          if (
                            itemToShow !== undefined &&
                            itemToShow !== null &&
                            itemToShow !== ''
                          ) {
                            if (itemToShow == 5) {
                              return (this.slidesToShow = itemToShow);
                            } else {
                              return (this.slidesToShow = itemToShow);
                            }
                          } else {
                            return (this.slidesToShow = 1);
                          }
                        },
                        get slidesToScroll() {
                          if (
                            itemToShow !== undefined &&
                            itemToShow !== null &&
                            itemToShow !== ''
                          ) {
                            if (itemToShow == 5) {
                              return (this.slidesToScroll = itemToShow - 1);
                            } else {
                              return (this.slidesToScroll = itemToShow);
                            }
                          } else {
                            return (this.slidesToScroll = 1);
                          }
                        },
                      },
                    },
                    {
                      breakpoint: 991,
                      settings: {
                        arrows: itemArrowsMb,
                        dots: itemDotsMb,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                      },
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        arrows: itemArrowsMb,
                        dots: itemDotsMb,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                      },
                    },{
                      breakpoint:550,
                       settings: {
                        arrows: itemArrowsMb,
                        dots: itemDotsMb,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                      }
                      
                    },
                    {
                      breakpoint: 301,
                      settings: {
                        arrows: itemArrowsMb,
                        dots: itemDotsMb,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                      },
                    },
                  ],
                });
              }
            }
          }
        },
      });
    }
  };

  return {
    resizeImage: function (src, size) {
      if (size == null) {
        return src;
      }

      if (size == 'master') {
        return src.replace(/http(s)?:/, '');
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i
      );

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
      } else {
        return null;
      }
    },

    showMayLikProducts: function (params) {
      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);



      // Template and element where to insert.
     
      wrapper = jQuery('#' + config.wrapperId);
        productHandleQueue = config.productHandleQueue.split(',');
      var newproductHandleQueue = productHandleQueue.filter(function (el) {
        return el != "";
      });
      productHandleQueue = newproductHandleQueue;
   
      // How many products to show.
      config.howManyToShow = Math.min(
        productHandleQueue.length,
        config.howManyToShow
      );

      // If we have any to show.
      if (config.howManyToShow && wrapper.length) {
       
          doAlong();
        
      }
    },

    getConfig: function () {
      return config;
    },


  };
})();
